import * as S from "../styles";

const BottomWord = ({ currentWord, colorFor }) => {
  return (
    <S.Word>
      {currentWord
        ? currentWord.split("").map((letter, i) => (
            <div className="letter" key={i} style={colorFor(letter, i)}>
              {letter}
            </div>
          ))
        : "type".split("").map((letter, i) => (
            <div className="letter" key={i}>
              {letter}
            </div>
          ))}
    </S.Word>
  );
};

export default BottomWord;
